import { Button } from "@mantine/core";
import { useLogout } from "@src/hooks/use-logout";
import clsx from "clsx";
import type React from "react";

export const LogoutButton: React.FC<{ className?: string }> = ({
	className,
}) => {
	const logout = useLogout();

	return (
		<Button
			className={clsx(
				"min-w-30 border-border-default text-text-primary",
				"hover:bg-surface-subtle",
				className,
			)}
			radius="sm"
			variant="outline"
			onClick={logout}
		>
			Log out
		</Button>
	);
};
